export const MORNING_BRIEFING_START_HOUR = 6;
export const MORNING_BRIEFING_END_HOUR = 11;

export const EVENING_BRIEFING_START_HOUR = 17;
export const EVENING_BRIEFING_END_HOUR = 21;

// Tier-based impression caps (combined morning+evening per tier period)
export const TIER_IMPRESSION_CAPS: Record<number, number> = {
    1: 10,
    2: 8,
    3: 6,
    4: 4,
    5: 2,
};

// Internal rings (SDF/MSIT) get a higher Tier 1 cap (~60 days × 2 cards/day)
export const TIER_1_INTERNAL_IMPRESSION_CAP = 120;

// Cooldown days when transitioning to a lower tier.
// Tier 5 uses the same value when recycling — the cooldown and recycle
// period coincide, simplifying the model.
export const TIER_COOLDOWN_DAYS: Record<number, number> = {
    2: 2,
    3: 3,
    4: 4,
    5: 5,
};

export const MAX_TIER = 5;

export const FORCE_MORNING_BRIEFING_START_HOUR = 0;
export const FORCE_MORNING_BRIEFING_END_HOUR = 12;

export const FORCE_EVENING_BRIEFING_START_HOUR = 12;
export const FORCE_EVENING_BRIEFING_END_HOUR = 24;

export const CMMID_MORNING_BRIEFING = 'cmmuwjzeuoy';
export const CMMID_EVENING_BRIEFING = 'cmmtw8e0u46';
